const matrix1 = [
  '#00374b',
  '#004b63',
  '#00728b',
  '#038dbb',
  '#00a2d8',
  '#00c7ff',
  '#55d6fe',
  '#90e4fe',
  '#caf2fe',
]
const matrix2 = [
  '#001e5a',
  '#013078',
  '#0142a6',
  '#0057d5',
  '#0460ff',
  '#3689ff',
  '#75a7fe',
  '#aac4fd',
  '#d4e4fb',
]
const matrix3 = [
  '#12053d',
  '#180b51',
  '#2c1378',
  '#391b95',
  '#4a24b7',
  '#5a32eb',
  '#854ffb',
  '#b28cfb',
  '#dacafb',
]
const matrix4 = [
  '#2e0843',
  '#450f5d',
  '#63167e',
  '#77239d',
  '#9a2aba',
  '#bc37f2',
  '#d456ff',
  '#e395fb',
  '#f1c9fe',
]
const matrix5 = [
  '#3f051b',
  '#551126',
  '#7a193c',
  '#97274f',
  '#bb2a61',
  '#e73a79',
  '#ef6f9f',
  '#f6a3bf',
  '#f8d4e0',
]
const matrix6 = [
  '#5b0601',
  '#830d00',
  '#b51902',
  '#e12300',
  '#fe4310',
  '#fe634d',
  '#ff8c85',
  '#fcb5af',
  '#ffd8d9',
]
const matrix7 = [
  '#591c00',
  '#792a01',
  '#ac3f00',
  '#dc5100',
  '#fd6b00',
  '#ff8448',
  '#ffa47d',
  '#ffc4a8',
  '#fee2d6',
]
const matrix8 = [
  '#583400',
  '#794803',
  '#ab6702',
  '#d38306',
  '#ffaa00',
  '#ffb23c',
  '#ffc878',
  '#ffd8a8',
  '#ffebd3',
]
const matrix9 = [
  '#553d00',
  '#765700',
  '#a57c00',
  '#d5a209',
  '#ffc501',
  '#ffc940',
  '#fed374',
  '#fde5a7',
  '#fef3d5',
]
const matrix10 = [
  '#666002',
  '#888901',
  '#c2bd00',
  '#f4ed01',
  '#fdfb44',
  '#fbf968',
  '#fdfa91',
  '#fffcb5',
  '#fffcdb',
]
const matrix11 = [
  '#505600',
  '#717507',
  '#9ca50c',
  '#c6ce16',
  '#d8eb37',
  '#e4ef62',
  '#ebf38e',
  '#f1f7b7',
  '#f9f9dd',
]
const matrix12 = [
  '#283e0f',
  '#3b571c',
  '#4c7c28',
  '#649c31',
  '#75ba43',
  '#97d45f',
  '#b0dc87',
  '#cde9b8',
  '#e2ebda',
]

const colorMatrix = [
  matrix1,
  matrix2,
  matrix3,
  matrix4,
  matrix5,
  matrix6,
  matrix7,
  matrix8,
  matrix9,
  matrix10,
  matrix11,
  matrix12,
]

export { colorMatrix }
